module.exports = __webpack_public_path__ + "img/225.c68f2a23.jpg";